import React from "react";
import { InfoOutlined } from "@mui/icons-material";
import { Box, Typography } from "@mui/material";

interface HolidayProps {
  holidayName: string;
}

export default function HolidayWarning({ holidayName }: HolidayProps) {
  return (
    <Box display="flex" alignItems="center" mt={1}>
      <InfoOutlined sx={{ fontSize: 20 }} />
      <Box ml={1}>
        <Typography fontSize="12px">
          {holidayName
            ? `${holidayName}. Horário sujeito a alteração devido sua configuração de feriado.`
            : "Horário sujeito a alteração devido sua configuração de feriado."}
        </Typography>
      </Box>
    </Box>
  );
}
